import { createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';

export const selectCommand = createAction(types.COMMAND_SELECT);
export const selectCommandIcon = createAction(types.COMMAND_ICON_SELECT);
export const updateActiveCommand = createAction(types.UPDATE_ACTIVE_COMMAND);
export const cleanup = createAction(types.CLEANUP);
export const assetsExpired = createAction(types.ASSETS_EXPIRED);
export const updateScrollTimestamp = createAction(types.UPDATE_SCROLL_TIMESTAMP);
